/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Ev_CheckpointInputs */

const en_fw_notify_ev_checkpoint = /** @type {(inputs: Fw_Notify_Ev_CheckpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkpoint`)
};

const id_fw_notify_ev_checkpoint = /** @type {(inputs: Fw_Notify_Ev_CheckpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkpoint`)
};

/**
* | output |
* | --- |
* | "Checkpoint" |
*
* @param {Fw_Notify_Ev_CheckpointInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_ev_checkpoint = /** @type {((inputs?: Fw_Notify_Ev_CheckpointInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Ev_CheckpointInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_ev_checkpoint(inputs)
	return en_fw_notify_ev_checkpoint(inputs)
});